import React, { Component } from "react";
import { Link } from "react-router-dom";
import { theme } from "../../assets/theme/theme";

class TrainingRequestDetail extends Component {
  renderStatus(status) {
    const map = {
      "Pending Approval": { bg: "#FFF7E6", color: "#B76E00" },
      Approved: { bg: "#ECFDF3", color: "#027A48" },
      Rejected: { bg: "#FEECEC", color: "#B42318" },
      Completed: { bg: "#EAF8FB", color: "#027A7A" },
      Draft: { bg: "#F1F5F9", color: "#475569" },
    };

    const s = map[status] || map.Draft;

    return (
      <span
        style={{
          background: s.bg,
          color: s.color,
          padding: "6px 12px",
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 800,
        }}
      >
        {status}
      </span>
    );
  }

  renderInfoRow(label, value) {
    return (
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#64748B" }}>{label}</div>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#0F172A", marginTop: 4 }}>
          {value || "-"}
        </div>
      </div>
    );
  }

  renderSection(title, children) {
    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 12,
          padding: 20,
          marginBottom: 18,
        }}
      >
        <h5 style={{ margin: "0 0 18px", fontWeight: 800 }}>{title}</h5>
        {children}
      </div>
    );
  }

  renderCostRow(label, amount, bold = false) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 0",
          borderBottom: bold ? "none" : "1px solid #EEF2F7",
          fontSize: 14,
          fontWeight: bold ? 800 : 600,
          color: bold ? "#0F172A" : "#334155",
        }}
      >
        <span>{label}</span>
        <span>RM {Number(amount || 0).toFixed(2)}</span>
      </div>
    );
  }

  renderTimeline() {
    const items = [
      ["Submitted", "Ho Boon Hock submitted the request.", "24 Apr 2026, 09:30 AM", true],
      ["Manager Review", "Pending manager approval.", "-", false],
      ["Finance Review", "Waiting for finance verification.", "-", false],
      ["Completed", "Request completed.", "-", false],
    ];

    return (
      <div>
        {items.map((item, index) => (
          <div key={index} style={{ display: "flex", gap: 12, marginBottom: 18 }}>
            <div
              style={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                background: item[3] ? theme.colors.brand.primary : "#E5E7EB",
                color: item[3] ? "#fff" : "#94A3B8",
                textAlign: "center",
                lineHeight: "24px",
                fontSize: 12,
                fontWeight: 800,
                flexShrink: 0,
              }}
            >
              {index + 1}
            </div>

            <div>
              <div style={{ fontSize: 13, fontWeight: 800, color: "#0F172A" }}>{item[0]}</div>
              <div style={{ fontSize: 12, color: "#64748B", marginTop: 3 }}>{item[1]}</div>
              <div style={{ fontSize: 11, color: "#94A3B8", marginTop: 3 }}>{item[2]}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const data = {
      request_id: "TRN-2026-0012",
      status: "Pending Approval",
      course_title: "Digital Marketing Masterclass",
      provider: "AIM Academy",
      training_type: "External",
      category: "Marketing",
      start_date: "15 Jun 2026",
      end_date: "17 Jun 2026",
      days: "3",
      venue: "Kuala Lumpur Convention Centre",
      location: "Kuala Lumpur",
      requested_by: "Ho Boon Hock",
      department: "Digitalisation",
      reason:
        "To improve digital campaign planning, reporting, and marketing performance for upcoming tourism and business event initiatives.",
      costs: {
        course_fee: 1800,
        travel: 450,
        accommodation: 600,
        meal: 180,
        miscellaneous: 120,
      },
    };

    const total =
      data.costs.course_fee +
      data.costs.travel +
      data.costs.accommodation +
      data.costs.meal +
      data.costs.miscellaneous;

    return (
      <div style={{ padding: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 20,
          }}
        >
          <div>
            <Link
              to="/training/request"
              style={{
                color: theme.colors.brand.primary,
                fontSize: 13,
                fontWeight: 700,
                textDecoration: "none",
              }}
            >
              ← Back to Training Request
            </Link>

            <h4 style={{ margin: "12px 0 6px", fontWeight: 800 }}>
              {data.course_title}
            </h4>

            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <span style={{ color: "#64748B", fontSize: 13 }}>{data.request_id}</span>
              {this.renderStatus(data.status)}
            </div>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <button style={secondaryButton}>Download PDF</button>
            <button style={primaryButton}>Edit Request</button>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 1fr",
            gap: 18,
          }}
        >
          <div>
            {this.renderSection(
              "Training Information",
              <div style={grid2}>
                {this.renderInfoRow("Course / Program", data.course_title)}
                {this.renderInfoRow("Provider / Organiser", data.provider)}
                {this.renderInfoRow("Training Type", data.training_type)}
                {this.renderInfoRow("Training Category", data.category)}
                {this.renderInfoRow("Start Date", data.start_date)}
                {this.renderInfoRow("End Date", data.end_date)}
                {this.renderInfoRow("Number of Days", data.days)}
                {this.renderInfoRow("Location", data.location)}
                <div style={{ gridColumn: "1 / span 2" }}>
                  {this.renderInfoRow("Venue", data.venue)}
                </div>
              </div>
            )}

            {this.renderSection(
              "Training Reason",
              <p style={{ margin: 0, color: "#334155", lineHeight: "24px", fontSize: 14 }}>
                {data.reason}
              </p>
            )}

            {this.renderSection(
              "Estimated Costing",
              <div>
                {this.renderCostRow("Course Fee", data.costs.course_fee)}
                {this.renderCostRow("Air Ticket / Travel / Visa", data.costs.travel)}
                {this.renderCostRow("Accommodation", data.costs.accommodation)}
                {this.renderCostRow("Meal Allowance", data.costs.meal)}
                {this.renderCostRow("Miscellaneous", data.costs.miscellaneous)}
                <div
                  style={{
                    marginTop: 12,
                    padding: 14,
                    background: "#F8FAFC",
                    borderRadius: 8,
                  }}
                >
                  {this.renderCostRow("Total Estimated Cost", total, true)}
                </div>
              </div>
            )}

            {this.renderSection(
              "Supporting Documents",
              <div>
                {["Course timetable.pdf", "Trainer profile.pdf", "Course quotation.pdf"].map(
                  (file) => (
                    <div
                      key={file}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        border: "1px solid #E5E7EB",
                        borderRadius: 8,
                        padding: "12px 14px",
                        marginBottom: 10,
                      }}
                    >
                      <span style={{ fontSize: 13, fontWeight: 700 }}>{file}</span>
                      <button style={secondaryButton}>View</button>
                    </div>
                  )
                )}
              </div>
            )}
          </div>

          <div>
            {this.renderSection(
              "Requester",
              <div>
                {this.renderInfoRow("Name", data.requested_by)}
                {this.renderInfoRow("Department", data.department)}
                {this.renderInfoRow("Submitted Date", "24 Apr 2026")}
              </div>
            )}

            {this.renderSection("Approval Timeline", this.renderTimeline())}

            {this.renderSection(
              "Actions",
              <div style={{ display: "grid", gap: 10 }}>
                <button style={primaryButton}>Approve</button>
                <button style={dangerButton}>Reject</button>
                <button style={secondaryButton}>Request More Info</button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "4px 22px",
};

const primaryButton = {
  background: theme.colors.brand.primary,
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 16px",
  fontWeight: 800,
  cursor: "pointer",
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 14px",
  fontWeight: 700,
  cursor: "pointer",
};

const dangerButton = {
  background: "#B42318",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 16px",
  fontWeight: 800,
  cursor: "pointer",
};

export default TrainingRequestDetail;